import React, { useEffect, useState } from "react";
import Header from "../../components/Header/Header";
import s from "./Services.module.scss";
import { Link } from "react-router-dom";
import { Table, Tooltip } from "antd";
import type { TableColumnsType } from "antd";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import Footer from "../../components/Footer/Footer";
import { AppDispatch, RootState } from "../../redux/store";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteService,
  getServiceDetails,
  getServicesList,
} from "../../redux/ServiceSlice";
import { toast, ToastContainer } from "react-toastify";
import { useTranslation } from "react-i18next";

interface TableType {
  id?: number;
  service: string;
  country: string;
  company: string;
  price: string;
  comment?: string;
  edit?: React.ReactNode;
  delete?: React.ReactNode;
}

const Services = () => {
  const dispath: AppDispatch = useDispatch();
  const { t } = useTranslation();
  const services = useSelector(
    (state: RootState) => state.service.servicesList,
  );

  const [data, setData] = useState(services?.results);
  const columns: TableColumnsType<TableType> = [
    {
      title: "№",
      dataIndex: "number",
      width: 50,
      align: "center",
    },
    {
      title: t("Наименование услуги"),
      dataIndex: `service`,
      width: 500,
      render: (text) => <div className={s.font}>{text}</div>,
    },
    {
      title: t("Страна"),
      dataIndex: `country`,
      render: (text) => <div className={s.font}>{text}</div>,
      width: 200,
    },
    {
      title: t("Брокер/Компания"),
      dataIndex: `company`,
      width: 500,
      render: (text) => <div className={s.font}>{text}</div>,
    },

    {
      title: t("Цена, USD"),
      dataIndex: `price`,
      align: "center",
      width: 150,
    },

    {
      title: t("Комментарий"),
      dataIndex: `comment`,
      width: 500,
    },
    {
      title: "",
      dataIndex: `edit`,
      width: 50,
      align: "center",
    },
    {
      title: "",
      dataIndex: `delete`,
      width: 50,
      align: "center",
    },
  ];

  useEffect(() => {
    if (services) {
      setData(services.results);
    }
  }, [services]);

  const deleteMangerService = async (id: number) => {
    const res = await dispath(deleteService(id));
    console.log("res", res);

    if (res.type === "services/deleteService/fulfilled") {
      dispath(getServicesList(1));
      toast.success("Вы удалили услугу");
    }
  };

  return (
    <div>
      <ToastContainer />
      <Header />
      <div className={s.services}>
        <div className={s.header}>
          <h2 className={s.h2}>{t("Все услуги")}</h2>
          <Link to="/createService" className={s.add_btn}>
            {t("Добавить новую услугу")}
          </Link>
        </div>
        <div className={s.table}>
          <Table<TableType>
            bordered
            className="table"
            columns={columns}
            dataSource={data?.map((it, index) => ({
              id: it.id,
              number: index + 1,
              service: it.service_name,
              country: it.country_name,
              company: `${it?.broker_name} - ${it?.broker_email}`,
              price: it?.price,
              comment: it?.comment,
              edit: (
                <div className={s.edit}>
                  <Link
                    to={`/service/${it.id}`}
                    className={s.edit}
                    onClick={() => dispath(getServiceDetails(it.id))}
                  >
                    <Tooltip title="Просмотр/Редактирование" key={2}>
                      <EditOutlined className={s.icon} />
                    </Tooltip>
                  </Link>
                </div>
              ),
              delete: (
                <div
                  className={s.edit}
                  onClick={() => deleteMangerService(it.id)}
                >
                  <Tooltip title={t("Удалить услугу")} key={2}>
                    <DeleteOutlined className={s.icon} />
                  </Tooltip>
                </div>
              ),
            }))}
          />
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Services;
